/** Converts a string into camelCase */
export function camelize (str: string): string {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

export function capitalize (str: string): string {
  return str[0].toUpperCase() + str.substring(1);
}
